import { InnerPageChrome } from "@/components/layout/InnerPageChrome";

import styles from "./PlaceholderPage.module.scss";

type PlaceholderPageProps = {
  eyebrow: string;
  title: string;
  intro: string;
};

export function PlaceholderPage({ eyebrow, title, intro }: PlaceholderPageProps) {
  return (
    <InnerPageChrome currentPath="">
      <section className={styles.page}>
        <div className={styles.panel}>
          <span className={styles.eyebrow}>{eyebrow}</span>
          <h1 className={styles.title}>{title}</h1>
          <p className={styles.intro}>{intro}</p>

          <div className={styles.links}>
            <a className={styles.link} href="/">
              Home
            </a>
            <a className={styles.link} href="/our-identity/">
              Identity
            </a>
          </div>
        </div>
      </section>
    </InnerPageChrome>
  );
}
